//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImagePicker from '@/components/innovation/ImagePicker.vue'
import { resolveMediaUrl } from '@/utils/mediaUrl'
import { openWordStudy } from '@/utils/openWordStudy'

export default {
  components: { ImagePicker },
  data () {
    return {
      palace: {},
      anchors: [],
      editBg: false,
      meta: { backgroundImage: '' },
      dragMode: false,
      dragId: null,
      moved: false
    }
  },
  computed: {
    bound () {
      return this.anchors.filter(a => a.wordId || a.word_id).length
    },
    mapStyle () {
      const bg = this.palace.backgroundImage || this.palace.background_image
      const color = this.palace.themeColor || this.palace.theme_color || '#1E3A5F'
      if (bg) {
        return {
          backgroundImage: 'url(' + resolveMediaUrl(bg) + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: color
        }
      }
      return { background: 'linear-gradient(145deg, ' + color + ', #4a90e2)' }
    }
  },
  created () { this.load() },
  methods: {
    pinStyle (a) {
      const x = a.positionX != null ? a.positionX : a.position_x
      const y = a.positionY != null ? a.positionY : a.position_y
      return { left: (x || 20) + '%', top: (y || 20) + '%' }
    },
    load () {
      this.$ajax.get(this.$api.mpPalaceDetail + '?id=' + this.$route.query.id).then(r => {
        this.palace = (r && r.palace) || {}
        this.anchors = (r && r.anchors) || []
        this.meta.backgroundImage = this.palace.backgroundImage || this.palace.background_image || ''
      })
    },
    toggleDrag () {
      this.dragMode = !this.dragMode
      this.dragId = null
      this.$toast && this.$toast(this.dragMode ? '拖动模式已开' : '已退出拖动')
    },
    onPinClick (a) {
      if (this.dragMode || this.moved) {
        this.moved = false
        return
      }
      // 已绑词：直接去学习页；未绑：去绑定
      if (this.wordOf(a)) {
        this.study(a)
      } else {
        this.edit(a)
      }
    },
    wordOf (a) {
      return (a && (a.wordText || a.word_text || a.word)) || ''
    },
    meanOf (a) {
      const m = (a && (a.wordMeaning || a.word_meaning || a.meaning)) || ''
      return String(m).slice(0, 40)
    },
    onPinTouchStart (e, a) {
      if (!this.dragMode) return
      this.dragId = a.id
      this.moved = false
      this.moveToEvent(e.touches[0], a)
    },
    onTouchMove (e) {
      if (!this.dragId || !e.touches || !e.touches[0]) return
      const a = this.anchors.find(x => x.id === this.dragId)
      if (!a) return
      this.moved = true
      this.moveToEvent(e.touches[0], a)
    },
    onTouchEnd () {
      this.commitDrag()
    },
    onPinMouseDown (e, a) {
      if (!this.dragMode) return
      this.dragId = a.id
      this.moved = false
      this.moveToEvent(e, a)
    },
    onMouseMove (e) {
      if (!this.dragId) return
      const a = this.anchors.find(x => x.id === this.dragId)
      if (!a) return
      this.moved = true
      this.moveToEvent(e, a)
    },
    onMouseUp () {
      this.commitDrag()
    },
    moveToEvent (point, a) {
      const box = this.$refs.mapBox
      if (!box || !point) return
      const rect = box.getBoundingClientRect()
      let x = ((point.clientX - rect.left) / rect.width) * 100
      let y = ((point.clientY - rect.top) / rect.height) * 100
      x = Math.max(5, Math.min(95, x))
      y = Math.max(5, Math.min(95, y))
      this.$set(a, 'positionX', Math.round(x * 10) / 10)
      this.$set(a, 'position_x', a.positionX)
      this.$set(a, 'positionY', Math.round(y * 10) / 10)
      this.$set(a, 'position_y', a.positionY)
    },
    commitDrag () {
      if (!this.dragId || !this.moved) {
        this.dragId = null
        return
      }
      const a = this.anchors.find(x => x.id === this.dragId)
      const id = this.dragId
      this.dragId = null
      if (!a) return
      const x = a.positionX != null ? a.positionX : a.position_x
      const y = a.positionY != null ? a.positionY : a.position_y
      this.$ajax.post(this.$api.mpAnchorUpdate, {
        id: id,
        position_x: x,
        position_y: y
      }).catch(e => {
        this.$toast && this.$toast(e.message || '位置保存失败')
        this.load()
      })
    },
    edit (a) {
      this.$router.push({
        path: '/mpAnchorEdit_display',
        query: { id: a.id, palace_id: this.palace.id }
      })
    },
    study (a) {
      openWordStudy(this.$router, this.wordOf(a))
    },
    saveBg () {
      this.$ajax.post(this.$api.mpPalaceUpdate, {
        id: this.palace.id,
        background_image: this.meta.backgroundImage || null
      }).then(() => {
        this.$toast && this.$toast('背景已更新')
        this.editBg = false
        this.load()
      }).catch(e => {
        this.$toast && this.$toast(e.message || '保存失败')
      })
    },
    roam () {
      if (!this.bound) {
        this.$toast && this.$toast('请先绑定至少一个单词')
        return
      }
      this.$router.push({ path: '/mpRoam_display', query: { id: this.palace.id } })
    },
    test () {
      if (!this.bound) {
        this.$toast && this.$toast('请先绑定至少一个单词')
        return
      }
      this.$router.push({ path: '/mpTest_display', query: { id: this.palace.id } })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/memory-palace/detail.vue